<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { fade } from "svelte/transition";
  import type { NavItem } from "$lib/gql/genCms/codegen";
  import Container from "$lib/components/Container/Container.svelte";
  import NavLinkList from "../NavLinkList/NavLinkList.svelte";

  export let menuOverlayOpen: boolean = true;
  export let navItems: NavItem[];
  export let dark = false;
  export let bg = true;

  $: visibleNavItems =
    navItems && navItems.filter(item => item?.hidden === false);

  let viewportWidth: number;

  let promo: boolean = false;
  let twoColumnLayout: boolean = false;

  const dispatch = createEventDispatcher();

  $: twoColumnLayout =
    navItems &&
    visibleNavItems.length === 2 &&
    (navItems[0].promoimage !== undefined ||
      navItems[1].promoimage !== undefined);
</script>

<style lang="scss">
  .nav-menu-overlay {
    position: absolute;
    left: -3.25rem;
    right: 0;
    background: $inverse-on-surface;
    color: $on-surface;
    cursor: default;
    z-index: 1001;
    max-width: $container-max;
    top: 100%;
    border-bottom: 1px solid $background;
    border-top: 1px solid $background;
    opacity: 1;
    visibility: visible;
    transition:
      visibility 0.3s linear,
      opacity 0.3s linear;

    &.dark {
      border-top: 1px solid $background;
    }

    @include retina {
      border-bottom: 0.5px solid $background;

      &.dark {
        border-bottom: 0.5px solid $background;
      }
    }

    @include breakpoint(xl) {
      left: -4rem;
    }
    @include breakpoint(xxl) {
      left: -6rem;
    }

    &__hidden {
      visibility: hidden;
      opacity: 0;
    }

    &--bg {
      position: absolute;
      background-color: $inverse-on-surface-30;
      top: 100%;
      left: -3.25rem;
      right: 0;
      z-index: -1;
      bottom: 0;
      height: 100vh;
      pointer-events: none;
      max-width: $container-max;

      @include breakpoint(xl) {
        left: -4rem;
      }
      @include breakpoint(xxl) {
        left: -6rem;
      }

      &__hidden {
        display: none;
      }
    }

    &--wrapper {
      padding: 48px 0;
      display: grid;
      grid-gap: 24px;
      min-height: 400px;

      @include breakpoint(xl) {
        gap: 32px;
      }

      @include breakpoint(xxl) {
        gap: 36px;
      }
    }

    &--list {
      &__default {
        &:first-child {
          grid-row: 1 / 2;
        }

        &:nth-child(2) {
          margin-top: -32px;
          padding-top: 32px;
          grid-row: 2 / 2;
        }
      }
    }
    &--flex {
      display: flex;
      flex-direction: column;
      &-item {
        padding-bottom: 24px;
      }
    }

    &--border {
      border-right: 1px solid $on-surface-10;
      padding-right: 24px;

      @include breakpoint(xl) {
        padding-right: 32px;
      }

      @include breakpoint(xxl) {
        padding-right: 36px;
      }

      &:last-child {
        border: none;
      }
    }

    &.promos {
      .nav-menu-overlay--wrapper {
        grid-template-columns: repeat(4, 1fr);
        padding: 24px 16px 48px;

        > * {
          grid-row: auto;
        }

        > .nav-menu-overlay--list {
          margin: 0 24px;
        }
      }
    }
  }
</style>

<svelte:window bind:innerWidth={viewportWidth} />

{#if navItems}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="nav-menu-overlay {promo ? 'promos' : ''} {menuOverlayOpen
      ? ''
      : 'nav-menu-overlay__hidden'}"
    class:dark
    on:mouseenter={() => dispatch("hover", true)}
    on:mouseleave={() => dispatch("hover", false)}
    transition:fade={{ duration: 300 }}
    style={`width: ${viewportWidth}px`}
  >
    <Container>
      <div
        class="nav-menu-overlay--wrapper"
        style={`
     grid-template-columns: repeat(${
       visibleNavItems.length >= 7 ? 6 : visibleNavItems.length
     }, 1fr);
      `}
      >
        {#if visibleNavItems.length >= 7}
          <div class="nav-menu-overlay--flex nav-menu-overlay--border">
            {#each visibleNavItems.slice(0, 2) as navItem}
              <div class="nav-menu-overlay--flex-item">
                <NavLinkList {navItem} on:selectItem {twoColumnLayout} />
              </div>
            {/each}
          </div>

          {#each visibleNavItems.slice(2, 7) as navItem}
            <div class="nav-menu-overlay--border">
              <NavLinkList {navItem} on:selectItem {twoColumnLayout} />
            </div>
          {/each}
        {:else}
          {#each visibleNavItems.slice(0, 7) as navItem}
            <div
              class={`nav-menu-overlay--border ${
                visibleNavItems.length < 7
                  ? ""
                  : "nav-menu-overlay--list__default"
              }`}
            >
              <NavLinkList {navItem} on:selectItem {twoColumnLayout} />
            </div>
          {/each}
        {/if}
      </div>
    </Container>
  </div>
  {#if bg}
    <div
      class="nav-menu-overlay--bg {menuOverlayOpen
        ? ''
        : 'nav-menu-overlay--bg__hidden'}"
      transition:fade={{ duration: 300 }}
      style={`width: ${viewportWidth}px`}
    />
  {/if}
{/if}
